import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fromBytes'
})
export class FromBytesPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value) {
      if (value.match(/.*(?=\.)/)) {
        if (value.match(/.*(?=\.)/)[0]) {
          const integer = value.match(/.*(?=\.)/)[0];
          if (integer.length > 6) {
            return (integer / 1000 / 1000).toFixed(2) + ' MB';
          } else if (integer.length > 3) {
            return (integer / 1000).toFixed(2) + ' KB';
          }
        }
      } else {
        if (value.length > 6) {
          return (value / 1000 / 1000).toFixed(2) + ' MB';
        } else if (value.length > 3) {
          return (value / 1000).toFixed(2) + ' KB';
        }
      }
    }
    return null;
  }

}
